import { useAutoRefillStore } from '../../../stores/useAutoRefillStore';
import type { AutoRefillPrescription } from '../../../types/api';

interface AutoRefillTableProps {
  prescriptions: AutoRefillPrescription[];
}

function formatDate(dateStr: string | undefined): string {
  if (!dateStr) {
    return '';
  }
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) {
    return dateStr;
  }
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
}

export function AutoRefillTable({ prescriptions }: AutoRefillTableProps) {
  const { isPatientAutoRefillEnabled, togglePrescription } = useAutoRefillStore();

  return (
    <div className="panel-body">
      <div>
        <table
          border={0}
          cellPadding={0}
          cellSpacing={0}
          className="refill-table table-striped"
          id="refills"
        >
          <thead id="fixedHeader">
            <tr>
              <th>Activate Auto-Refill</th>
              <th style={{ textAlign: 'left' }}>Rx#</th>
              <th style={{ textAlign: 'left' }}>Drug Name</th>
              <th>Days Supply</th>
              <th>Refills Remaining</th>
              <th>Next Refill Available After</th>
              <th>Expire Date</th>
            </tr>
          </thead>
          <tbody className="refill-table-list">
            {prescriptions.map(refill => (
              <tr key={refill.ScriptNo} className="refill-table-row">
                <td style={{ textAlign: 'center' }}>
                  <input
                    type="checkbox"
                    checked={refill.IsAutoRefillEnabled ?? false}
                    disabled={!isPatientAutoRefillEnabled}
                    onChange={e => togglePrescription(refill.ScriptNo ?? '', e.target.checked)}
                  />
                </td>
                <td>{refill.ScriptNo}</td>
                <td>{refill.DrugName}</td>
                <td style={{ textAlign: 'center' }}>{refill.DaysSupply}</td>
                <td style={{ textAlign: 'center' }}>{refill.NumRefillsLeft}</td>
                <td style={{ textAlign: 'center' }}>{formatDate(refill.NextRefillDate)}</td>
                <td style={{ textAlign: 'center' }}>{formatDate(refill.ExpirationDate)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
